import {createAction} from "redux-act";

export interface IWeeklyPrizeModal {
	modals: {
		language: string;
		header: string;
		title: string;
		description: string;
		image: string;
	}[]
}

export const fetchWeeklyPrizeModal = createAction();
export const fetchWeeklyPrizeModalsSuccess = createAction<IWeeklyPrizeModal>();
export const fetchWeeklyPrizeModalSuccess = createAction<IWeeklyPrizeModal["modals"][number]>();
export const clearWeeklyPrizeModal = createAction();

export const fetchWeeklyPrizeModalError = createAction();
